import React from "react";
import PropTypes from "prop-types";
import { Form } from "antd";

import FormInput from "./formInput";

const propTypes = {
  autoFocus: PropTypes.bool,
  horizontal: PropTypes.bool,
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  error: PropTypes.string,

  formLayout: PropTypes.shape({
    labelCol: PropTypes.object,
    wrapperCol: PropTypes.object,
  }),
  inputProps: PropTypes.object,
  inputStyle: PropTypes.object,
};

const defaultProps = {
  autoFocus: false,
  error: null,
  horizontal: false,
  label: false,
  formLayout: {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  },
  inputProps: {},
  inputStyle: {},
};

const formItemLayout = (horizontal, formLayout) => {
  if (horizontal === true) {
    return formLayout;
  }
  return null;
};

const translateLabel = (label, name) => {
  if (label === false) {
    return null;
  }

  if (label === true) {
    //   const translate = R.path(R.split('.', humps.decamelize(name)), i18n.activerecord.attributes);
    //   return translate;
    return name;
  }

  return label;
};

function FormGroup({
  autoFocus,
  input,
  meta: { error, touched, submitError },
  label,
  horizontal,
  formLayout,
  style,
  inputStyle,
  inputProps: inputComponentProps,
  ...rest
}) {
  const id = input.name;

  const formGroupProps = {
    id,
    label: label ? translateLabel(label, input.name) : null,
    ...formItemLayout(horizontal, formLayout),
    style,
  };

  const inputProps = {
    id,
    autoFocus,
    ...input,
    ...rest,
    ...inputComponentProps,
  };

  return (
    <Form.Item
      {...formGroupProps}
      validateStatus={touched && error ? "error" : null}
      help={touched && error ? error : null}
    >
      <FormInput {...inputProps} style={inputStyle} />
    </Form.Item>
  );
}

FormGroup.propTypes = propTypes;
FormGroup.defaultProps = defaultProps;

export default FormGroup;
